<template>
  <transition name="toast-slide">
    <div v-if="isVisible" class="stella-toast shadow-lg d-flex align-items-center" :class="`toast-${type}`">
      <div class="toast-icon me-3 d-flex align-items-center justify-content-center">
        <i v-if="type === 'success'" class="fa fa-check-circle font-size-20" style="color: #70D5C2;"></i>
        <i v-else-if="type === 'error'" class="fa fa-exclamation-circle font-size-20" style="color: #E53BB9;"></i>
        <i v-else-if="type === 'warning'" class="fa fa-exclamation-triangle font-size-20" style="color: #F3DA6B;"></i>
        <i v-else class="fa fa-info-circle font-size-20" style="color: #70D5C2;"></i>
      </div>
      <div class="toast-content flex-grow-1">
        <p class="mb-0 text-white font-size-14 font-weight-500" v-html="message"></p>
      </div>
      <div class="toast-close ms-3 cursor-pointer d-flex align-items-center" @click="hide()">
        <i class="fa fa-times text-white-50 font-size-16 hover-white"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastNotification",
  data() {
    return {
      isVisible: false,
      message: '',
      type: 'info', // 'success', 'error', 'warning', 'info'
      duration: 3500,
      timer: null
    };
  },
  methods: {
    show(message, type = 'info', duration = 3500) {
      this.message = message;
      this.type = type;
      this.duration = duration;
      this.isVisible = true;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.hide();
        }, this.duration);
      }
    },
    hide() {
      this.isVisible = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }
};
</script>

<style scoped>
.stella-toast {
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: auto;
  min-width: 220px;
  max-width: 440px;
  border-radius: 50px;
  padding: 12px 20px;
  z-index: 100000;
  background: rgba(18, 18, 22, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.55);
}

@media (max-width: 576px) {
  .stella-toast {
    right: 16px;
    left: 16px;
    bottom: 20px;
    max-width: calc(100% - 32px);
    border-radius: 16px;
  }
}

@media (min-width: 768px) {
  .stella-toast {
    right: 32px;
  }
}

.toast-error {
  border-color: rgba(229, 59, 185, 0.45) !important;
  box-shadow: 0 8px 30px rgba(229, 59, 185, 0.25) !important;
}

.toast-success {
  border-color: rgba(112, 213, 194, 0.45) !important;
  box-shadow: 0 8px 30px rgba(112, 213, 194, 0.2) !important;
}

.toast-warning {
  border-color: rgba(243, 218, 107, 0.45) !important;
  box-shadow: 0 8px 30px rgba(243, 218, 107, 0.2) !important;
}

.toast-info {
  border-color: rgba(112, 213, 194, 0.35) !important;
}

.hover-white {
  transition: color 0.2s ease;
}
.hover-white:hover {
  color: #ffffff !important;
}

/* Make links white and underlined */
.stella-toast >>> a {
  color: #70D5C2 !important;
  text-decoration: underline !important;
  font-weight: 600;
}

/* Transitions */
.toast-slide-enter-active, .toast-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.toast-slide-enter, .toast-slide-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}
</style>
